import React from 'react';

export default function SuspendedPage() {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-slate-900 border border-white/10 rounded-2xl p-8 shadow-2xl">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-amber-500/10 flex items-center justify-center">
            <svg className="w-8 h-8 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-white mb-3">Account Access Paused</h1>
          <p className="text-white/70 text-sm mb-8 leading-relaxed">
            Your SurFox AI account access is currently paused. To restore access and get back to your data, please reach out and we'll get you back up and running.
          </p>
          <a
            href="mailto:admin@surfox.ai"
            className="inline-block w-full py-3 rounded-lg font-semibold text-white transition-all bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
}
